import { useTranslation } from "react-i18next";
import { useUIStore } from "../stores/uiStore";

/**
 * ADR 369 — the key legend for the walk camera, bottom-centre over the canvas
 * (the same slot EditModeHud uses; the two modes never coexist). Pointer
 * events pass through: the canvas underneath is where the click that locks
 * the mouse lands.
 */
export function WalkHud() {
  const { t } = useTranslation();
  const walkMode = useUIStore((s) => s.walkMode);
  if (!walkMode) return null;

  const keys: Array<[string, string]> = [
    ["WASD", t("controls.walk.move")],
    ["Mouse", t("controls.walk.look")],
    ["Shift", t("controls.walk.run")],
    ["Q / E", t("controls.walk.height")],
    ["X", t("controls.walk.ghost")],
    ["Esc", t("controls.walk.exit")],
  ];

  return (
    <div role="status" aria-label={t("controls.walk.title")} style={{
      position: "absolute",
      bottom: 80,
      left: "50%",
      transform: "translateX(-50%)",
      background: "rgba(5,18,46,0.88)",
      border: "1px solid var(--op-blue-500)",
      borderRadius: "var(--radius-lg)",
      padding: "10px 18px",
      fontFamily: "var(--font-mono)",
      fontSize: 12,
      color: "var(--op-blue-300)",
      pointerEvents: "none",
      display: "flex",
      gap: 20,
      zIndex: 40,
      whiteSpace: "nowrap",
    }}>
      {keys.map(([k, label]) => (
        <span key={k}><strong>{k}</strong> {label}</span>
      ))}
    </div>
  );
}
